export default __webpack_public_path__ + "static/media/gandr-logo-v2.7a2c1734.png";